var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as controlCenterActions from '../actions/control-center';
var initialState = {
  loading: false,
  phones: [],
  modifyingPhoneIds: [],
  error: null
};
export default function (state, action) {
  if (state === void 0) {
    state = initialState;
  }
  switch (action.type) {
    case controlCenterActions.LOADING:
      return __assign(__assign({}, state), {
        loading: true,
        error: null
      });
    case controlCenterActions.LOADED:
      return __assign(__assign({}, state), {
        loading: false,
        phones: action.phones,
        error: null
      });
    case controlCenterActions.LOAD_FAILED:
      return __assign(__assign({}, state), {
        loading: false,
        error: action.error
      });
    case controlCenterActions.ENABLING:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [action.id],
        error: null
      });
    case controlCenterActions.ENABLED:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [],
        error: null
      });
    case controlCenterActions.ENABLE_FAILED:
      return __assign(__assign({}, state), {
        error: action.error,
        modifyingPhoneIds: []
      });
    case controlCenterActions.DISABLING:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [action.id],
        error: null
      });
    case controlCenterActions.DISABLED:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [],
        error: null
      });
    case controlCenterActions.DISABLE_FAILED:
      return __assign(__assign({}, state), {
        error: action.error,
        modifyingPhoneIds: []
      });
    case controlCenterActions.ENABLING_MULTIPLE:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: action.ids,
        error: null
      });
    case controlCenterActions.ENABLED_MULTIPLE:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [],
        error: null
      });
    case controlCenterActions.ENABLE_MULTIPLE_FAILED:
      return __assign(__assign({}, state), {
        error: action.error,
        modifyingPhoneIds: []
      });
    case controlCenterActions.DISABLING_MULTIPLE:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: action.ids,
        error: null
      });
    case controlCenterActions.DISABLED_MULTIPLE:
      return __assign(__assign({}, state), {
        modifyingPhoneIds: [],
        error: null
      });
    case controlCenterActions.DISABLE_MULTIPLE_FAILED:
      return __assign(__assign({}, state), {
        error: action.error,
        modifyingPhoneIds: []
      });
  }
  return state;
}